import React from "react";

import classNames from "classnames";

import { Typography, Accordion } from "clearsense-ui/components";

import InformationCard from ".";

import { DEFAULT_CDES_JSON } from "../../constants";

const HierarchyField = ({
  field,
  fields,
  index,
  businessRules,
  expandedAccordions,
  parentHierarchyNumber,
}) => {
  fields[field]?.cde_values.map((_, idx) => {
    Object.assign(
      fields[field]?.cde_values?.[idx],
      Object.entries({
        ...DEFAULT_CDES_JSON?.[field]?.reduce(
          (acc, item) => ({ ...acc, ...item }),
          {}
        ),
        ...fields[field]?.cde_values?.[idx]?.reduce(
          (acc, item) => ({ ...acc, ...item }),
          {}
        ),
      }).map(([key, value]) => ({ [key]: value }))
    );
  });

  const generateExpandedHierarchyIndices = () => {
    if (
      index === 0 &&
      parentHierarchyNumber === 0 &&
      typeof expandedAccordions === "number"
    ) {
      return 0;
    } else if (typeof expandedAccordions === "object") {
      return expandedAccordions;
    }

    return [];
  };

  return (
    <Accordion
      multipleExpanded
      key={field}
      defaultActiveKey={generateExpandedHierarchyIndices()}
      className={classNames("border-[#d8dcde]", {
        "border-t": index !== 0,
      })}
    >
      <Accordion.Item
        title={
          <Typography type="medium" className="text-shades-darkest">
            {fields[field]?.display_name?.replace(" Hierarchy", "")}
          </Typography>
        }
        className="font-medium"
      >
        <div className="divide-y divide-dashed">
          {fields[field].cde_values?.map((_, idx) => (
            <InformationCard
              key={idx}
              isNestedHierarchy
              section={Object.values(fields)?.[0]?.cde_values}
              number={idx}
              businessRules={businessRules}
              expandedAccordions={expandedAccordions}
              parentHierarchyNumber={index}
            />
          ))}
        </div>
      </Accordion.Item>
    </Accordion>
  );
};

export default HierarchyField;
